import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/alteracao-exame-finalizado`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        getUnidades(queryParms) {

            return repository.get(`${baseUrl}/unidade-executante?${urlUtil.serialize(queryParms)}`)
        },
        getProfissional(queryParms) {

            return repository.get(`${baseUrl}/profissional-executante?${urlUtil.serialize(queryParms)}`)
        },
        getGrupoExames(queryParms) {

            return repository.get(`${baseUrl}/grupo-exame?${urlUtil.serialize(queryParms)}`)
        },
        getExames(queryParms) {

            return repository.get(`${baseUrl}/exame?${urlUtil.serialize(queryParms)}`)
        },
        datatable(queryParms) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        update(id, params) {

            return repository.put(`${baseUrl}/${id}`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
    }
}